import React, { useState, useEffect } from 'react';
import { getCredits } from '../../../../services/resume.service';

const CreditBadge = () => {
    const [credits, setCredits] = useState(0);
    const [loading, setLoading] = useState(true);

    const fetchCredits = async () => {
        try {
            const userId = localStorage.getItem('user_id');
            const category = localStorage.getItem('category');
            if (!userId || !category) return;

            const response = await getCredits(userId, category);
            if (response.success) {
                setCredits(response.credits);
            }
        } catch (error) {
            console.error('Failed to fetch credits:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCredits();

        // Refresh credits every 2 minutes as a backup
        const interval = setInterval(fetchCredits, 120000);

        // Listen for custom events triggered by other components after credit-consuming actions
        window.addEventListener('credits-updated', fetchCredits);

        return () => {
            clearInterval(interval);
            window.removeEventListener('credits-updated', fetchCredits);
        };
    }, []);

    if (loading) return (
        <div className="flex items-center gap-2 px-3 py-1 bg-slate-50 border border-slate-100 rounded-full animate-pulse h-8 w-32"></div>
    );

    // Calculate how many "big" actions are left (Resume Creation is 10, Gap/ATS is 5)
    // We'll show a safe estimate
    const resumesLeft = Math.max(0, Math.floor(credits / 10));

    return (
        <div className="flex items-center gap-3">
            <div className="flex flex-col items-end">
                <div className="flex items-center gap-1.5 px-3 py-1 bg-blue-50 border border-blue-100 rounded-full transition-all hover:bg-blue-100">
                    <span className="msi text-blue-500 text-[14px]">account_balance_wallet</span>
                    <span className="text-[12px] font-bold text-navy">{credits} / 100 Credits</span>
                </div>
                <span className="text-[9px] font-extrabold text-slate-400 uppercase tracking-widest mt-0.5">
                   ~{resumesLeft} Creations Left
                </span>
            </div>
        </div>
    );
};

export default CreditBadge;
